import { SET_TABLE_STATE, RESET_TABLE_STATE } from '../types/types';

export const setTableState = (tableName, stateData) => ({
    type: SET_TABLE_STATE,
    payload: { tableName, stateData }
});

export const resetTableState = (tableName) => ({
    type: RESET_TABLE_STATE,
    payload: { tableName }
});